<template>
  <v-container fluid fill-height>
    <v-row v-if="errors.length">
      <v-col>
        <v-alert type="error">
          <div v-for="(err,idx) in errors" :key="idx">
            {{err}}
          </div>
        </v-alert>
      </v-col>
    </v-row>
    <v-row v-if="!inventory">
      <v-col cols=12>
        <v-card>
          <v-toolbar color="secondary" dark>
            <v-toolbar-title>
              <v-icon left>mdi-wrench</v-icon>Picking
            </v-toolbar-title>
            <v-spacer />
            <v-btn v-if="tabs==0 " color="primary" @click="createAndStart" :disabled="buildInPickwave.length==0">Create and start Pick Wave with these {{buildInPickwave.length}} builds</v-btn>
            <create-box v-if="tabs==1" />
            <template v-slot:extension>
              <v-tabs v-model="tabs">
                <v-tab>To Be Picked</v-tab>
                <v-tab>Picked</v-tab>
                <v-tab>Handling</v-tab>
                <v-tab>Shipped</v-tab>
              </v-tabs>
            </template>
          </v-toolbar>
          <v-tabs-items v-model="tabs">
            <v-tab-item>
              <build-table status="new" />
            </v-tab-item>
            <v-tab-item>
              <pending-box-list />
            </v-tab-item>
            <v-tab-item>
              <build-table status="handling" />
            </v-tab-item>
            <v-tab-item>
              <build-table status="shipped" />
            </v-tab-item>
          </v-tabs-items>
        </v-card>
      </v-col>
    </v-row>
    <v-row v-else>
      <v-col>
        <v-alert type="error">
          L'inventaire de fin d'année est en cours, impossible de faire des pickings.
        </v-alert>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import CreateBox from '../../components/PendingBox/CreateBox.vue'
import { mapActions, mapGetters } from 'vuex';
import BuildTable from "@components/build/BuildTable.vue";
import PendingBoxList from '../../components/PendingBox/PendingBoxList.vue';
import hasQueryParams from '../../mixins/hasQueryParams.vue';

export default {
  name: 'BuildList',
  mixins: [hasQueryParams],
  components:{
    BuildTable,
    PendingBoxList,
    CreateBox,
  },
  data() {
    return {
      tabs: null,
      tableData: [],
      totalCount: 0,
      loading: null,
      options: { sortBy:['serviceLevel'], sortDesc:[true],rowsPerPage: 15 },
      queryFields: ['buildTab']
    };
  },
  computed:{
    ...mapGetters("pickwave", {buildInPickwave:"buildInPickwave",pickwaveLoading:"loading", pickwaveErrors:"errors"}),
    ...mapGetters("inventory", {inventory: 'inventory'}),
    errors(){
      let err = [
        ...this.pickwaveErrors
      ];
      return err;
    },
    query () {
      return {
        buildTab : this.tabs
      }
    }
  },
  mounted () {
    this.parseQuery()
    this.getInventory()
  },
  watch: {
    tabs () {
      this.pushNewRoute(true)
    }
  },
  methods: {
    ...mapActions("pickwave", { createAndStartPickWave:"createAndStartPickWave"}),
    ...mapActions("inventory", { getInventory:"getInventory"}),
    open(id) {
      this.$router.push("/build/build/" + id);
    },
    createAndStart(){
          let orderIds = this.buildInPickwave.map(build => build.order_id)
          this.createAndStartPickWave(orderIds).then(({pickwave}) => {
              this.$router.push({name:"Pick Wave Detail", params:{id:pickwave.id}})
          }).catch(err => {
              console.log(err)
          });

      },
    getServiceLevelColor(sl) {
      if (sl > 20) {
        return "red";
      }
      if (sl > 10) {
        return "orange";
      }
      if (sl > 0) {
        return "green";
      }
    },
    parseQuery(){
      this.tabs = this.$route.query.buildTab ? parseInt(this.$route.query.buildTab): 1
    },
  }
};
</script>

<style></style>
